import { render, staticRenderFns } from "./TreeForm.vue?vue&type=template&id=2add5d42&scoped=true"
import script from "./TreeForm.ts?vue&type=script&lang=ts&external"
export * from "./TreeForm.ts?vue&type=script&lang=ts&external"
import style0 from "./TreeForm.vue?vue&type=style&index=0&id=2add5d42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add5d42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2add5d42')) {
      api.createRecord('2add5d42', component.options)
    } else {
      api.reload('2add5d42', component.options)
    }
    module.hot.accept("./TreeForm.vue?vue&type=template&id=2add5d42&scoped=true", function () {
      api.rerender('2add5d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/FilesEditor/components/TreeForm/TreeForm.vue"
export default component.exports